module.exports = __webpack_public_path__ + "static/media/export-excel.788ac067.png";